import classNames from 'classnames'
import { CSSProperties, useMemo } from 'react'
import { RenderElementProps, useSlate } from 'slate-react'

import {
  getActionIcon,
  getActionIconColor,
} from 'core-components/library/richTextEditor/helpers/actionHelper'

import styles from './ActionBox.module.scss'

interface IProps {
  style: CSSProperties
}

export const ActionBox = (props: RenderElementProps & IProps) => {
  const editor = useSlate()
  const icon = useMemo(() => {
    return getActionIcon(props.element['format'])
  }, [props.element])
  const iconColor = useMemo(() => {
    return getActionIconColor(props.element['format'])
  }, [props.element])

  return (
    <section
      {...props.attributes}
      style={props.style}
      className={classNames(
        styles.root,
        editor.disabled ? styles['root--viewing-mode'] : styles['root--editor-mode']
      )}
    >
      <i className={classNames(styles.icon, icon, iconColor)} contentEditable={false} />
      <div className={styles.content}>{props.children}</div>
    </section>
  )
}
